// The controller that uses group_api service to get the data from the API and dispatch the actions to the reducer
import { useDispatch } from 'react-redux';

import { setApiResponseStatus } from '../../common/application/apiResponseStatusSlice';
import { handleHttpError } from '../../common/application/handleHttpError';
import { toggleToast } from '../../common/application/toastSlice';

import { RequestTypeEnum } from '@/common/domain/toast';
import useGroupApi from '@/group/data/groupApi';

export const useGroupConfigEnterprise = () => {
    const dispatch = useDispatch();
    const { apiDeleteGroupConfig, apiGetGroups } = useGroupApi();


    const deleteGroupConfigEnterprise = async (id: string) => {
        try {
            const response = await apiDeleteGroupConfig(id);
            handleHttpError(response.status);
            dispatch(setApiResponseStatus(response.status));
            const newGroups = await apiGetGroups(); // TODO remove, we wont need that we API will return updated group list
            return {
                data: newGroups,
                meta: response.meta,
                status: response.status,
            };
        } catch (error: any) {
            if (error?.status) {
                dispatch(toggleToast({ ...error.status, requestType: RequestTypeEnum.operationFailed }));
            }
        }
    };

   
    return {
        deleteGroupConfigEnterprise,
    };
};
